var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 278,
    viewBox: "0 0 315 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip0_120_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.997 30.6077L85.0215 54.5837L162.901 132.633L85.0215 210.683L108.997 234.659L211.023 132.633L108.997 30.6077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.055 30.6077L197.079 54.5837L274.959 132.633L197.079 210.683L221.055 234.659L323.081 132.633L221.055 30.6077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 314.424,
    height: 277.324,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.a1363ef9e08c93658f3a87a6300e792f.svg";
export { ForwardRef as ReactComponent };